import styled from 'styled-components';

interface FlexboxProps {
  $justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  $align?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  $direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  $wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  $gap?: string;
  $width?: string;
  $height?: string;
  $padding?: string;
  $margin?: string;
}

const Flexbox = styled.div<FlexboxProps>`
  display: flex;
  justify-content: ${({ $justify }) => $justify || 'flex-start'};
  align-items: ${({ $align }) => $align || 'stretch'};
  flex-direction: ${({ $direction }) => $direction || 'row'};
  flex-wrap: ${({ $wrap }) => $wrap || 'nowrap'};
  gap: ${({ $gap }) => $gap || '0'};
  width: ${({ $width }) => $width || 'auto'};
  height: ${({ $height }) => $height || 'auto'};
  padding: ${({ $padding }) => $padding || '0'};
  margin: ${({ $margin }) => $margin || '0'};
`;

export default Flexbox;